module.exports = __webpack_public_path__ + "static/media/hospitality.e538e275.jpg";